# frozen_string_literal: true

require_relative 'jaro_winkler/adjusting_table'
require_relative 'jaro_winkler/jaro_winkler_pure'
require_relative 'jaro_winkler/version'
